import { css } from 'styled-components';

export const heroStyle = css`
  font-size: ${(props) => props.theme.sizes.large};
  @media ${(props) => props.theme.device.tablet} {
    font-size: ${(props) => props.theme.sizes.xxlarge};
  }
  @media ${(props) => props.theme.device.laptopL} {
    font-size: ${(props) => props.theme.sizes.xxxlarge};
  }
`;

export const H1Style = css`
  font-size: ${(props) => props.theme.sizes.large};
  @media ${(props) => props.theme.device.tablet} {
    font-size: ${(props) => props.theme.sizes.xlarge};
  }
`;

export const H2Style = css`
  font-size: ${(props) => props.theme.sizes.medium};
  @media ${(props) => props.theme.device.tablet} {
    font-size: ${(props) => props.theme.sizes.large};
  }
`;

export const H3Style = css`
  font-size: ${(props) => props.theme.sizes.normedium};
  @media ${(props) => props.theme.device.tablet} {
    font-size: ${(props) => props.theme.sizes.medium};
  }
`;

export const H4Style = css`
  font-size: ${(props) => props.theme.sizes.normal};
  @media ${(props) => props.theme.device.tablet} {
    font-size: ${(props) => props.theme.sizes.normedium};
  }
`;

export const H5Style = css`
  font-size: ${(props) => props.theme.sizes.normal};
`;

export const subStyle = css`
  font-size: 1.125rem;
  font-weight: normal;
  color: ${(props) => props.theme.palette.greyBlack.main};
`;
